import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { Timeline } from 'antd-v5';
import { PurchaseOutline, MassMessages } from '../../../../Layout/Report/components/Icons';
import TimelineItem from '../../../../Layout/Report/components/Timeline';
import SalesItem from '../../../../Layout/Report/components/SalesTimelineItem';
import { getMassMessageAttributedSales } from '../../../../../services/massMessageReports';

const MassMessageExpandRow = ({
  massMessageId,
  associateName,
  scheduledDateTime,
  audienceSize,
  message = '',
  posType,
}) => {
  const [loading, setLoading] = useState(true);
  const [salesData, setSalesData] = useState([]);

  const fetchAttributedSales = useCallback(async () => {
    if (!posType) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const sales = await getMassMessageAttributedSales({ massMessageId });
      setSalesData(Array.isArray(sales) ? sales : []);
    } catch (error) {
      console.error('Error fetching attributed sales:', error);
      setSalesData([]);
    } finally {
      setLoading(false);
    }
  }, [massMessageId, posType]);

  useEffect(() => {
    fetchAttributedSales();
  }, [fetchAttributedSales]);

  return (
    <div className="m-left-23">
      <div className="flex-row-spacebetween-nowrap">
        <Timeline
          pending={loading ? 'Loading...' : null}
          items={[
            {
              children: (
                <MessageItem
                  associateName={associateName}
                  scheduledDateTime={scheduledDateTime}
                  audienceSize={audienceSize}
                  message={message}
                />
              ),
              dot: <MassMessages style={{ fontSize: '18px', opacity: 0.88 }} />,
            },
            ...salesData.map(sale => ({
              children: (
                <SalesItem
                  client_name={sale.clientName}
                  sales_transaction_amount={sale.transactionAmount}
                  description=""
                  activity_date={sale.salesTransactionDate}
                />
              ),
              dot: <PurchaseOutline style={{ color: '#389E0D', fontSize: '18px' }} />,
            })),
          ]}
        />
      </div>
    </div>
  );
};

export default MassMessageExpandRow;

const MessageItem = ({ associateName, scheduledDateTime, audienceSize, message }) => {
  return (
    <TimelineItem
      title={
        <>
          <span className="fw-600">{associateName || 'An Associate'} </span>sent a mass message to
          <span className="fw-600"> {audienceSize} recipients</span> on
          <span className="fw-600"> {moment(scheduledDateTime).format('MMM DD, YYYY')}</span>
        </>
      }
      description={message}
    />
  );
};
